module.exports = __webpack_public_path__ + "static/img/12.b23f963.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/12.png
// module id = AFYz
// module chunks = 0